enum FileExtension {
  MP4 = 'mp4',
  MOV = 'mov',
  MP3 = 'mp3',
  JPEG = 'jpeg',
  PNG = 'png',
  JPG = 'jpg',
  GIF = 'gif',
  HTML = 'html',
}

export default FileExtension;
